import React from "react";
import cn from "classnames";
import styles from "./ToteSuggestion.module.sass";

import moment from "moment";
const ToteSuggestion = ({ className, item, onClick }) => {
    const capitalizeFirstLetter = (string) => {
        return string
          ?.split("_")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
          .join(" ");
      };
  return (
    <div className={cn(styles.item, className)}>
      <div className={styles.link} onClick={onClick}>
        <div className={styles.details}>
          <div className={styles.name_container}>
            {" "}
            <div className={styles.title}>{item.data.tote_code}</div>
            <div className={styles.date_content}>
              {moment(item.data.created_at).format("YYYY-MM-DD")}
            </div>
          </div>

          <div className={styles.status_container}>
            {" "}
            <div
              className={cn({
                "status-role-active":
                  "Empty" === capitalizeFirstLetter(item.data.tote_status),
                "status-role-inactive":
                  "Empty" !== capitalizeFirstLetter(item.data.tote_status),
              })}
            >
              {capitalizeFirstLetter(
                item.data.tote_status ? item.data.tote_status : "-"
              )}
            </div>
           
          </div>
        </div>
      </div>
    </div>
  );
};

export default ToteSuggestion;
